import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

const Activity = () => (
  <Box className="dashboard-card">
    <Typography variant="h6">Your Activity</Typography>
    <Typography variant="body2" fontWeight="bold">
      Coming soon.
    </Typography>
    {/* <List dense>
      <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>•</Typography>
        <ListItemText 
          primary={<Typography variant="body2"><strong>you</strong> viewed Quarterly Update Q3 2025.pdf</Typography>}
        />
      </ListItem>
      <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>•</Typography>
        <ListItemText 
          primary={<Typography variant="body2"><strong>you</strong> downloaded Fund Factsheet (Oct 2025).pptx</Typography>}
        />
      </ListItem>
    </List> */}
  </Box>
);

export default Activity;